import styled from "styled-components";
import App from '@/containers/App/App';
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import { fetchProfile } from "../../actions/profileActions";
import { FETCH_PROFILE_SUCCESS } from "../../actions/types";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

const Wrapper = styled.div`
  max-height: 100vh;
  height: 100%;
`;

const AdminDashboard = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user, logout, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const checkUserAccess = (user) => {
    if ('manager' in user['metadata'] && user['metadata']['manager'] === true) {
      return;
    } else {
      history.push("/");
    }
  }

  useEffect(() => {
    const getUserMetadata = async () => {
      const domain = "fastmap.us.auth0.com";
      try {
        const accessToken = await getAccessTokenSilently({
          audience: `https://${domain}/api/v2/`,
        });
        localStorage.setItem("auth0_token", accessToken);
        localStorage.setItem("is_user_manager", 'manager' in user.metadata ? user.metadata.manager : false)
        dispatch({
          type: FETCH_PROFILE_SUCCESS,
          payload: user,
        });
        fetchProfile(dispatch);
        checkUserAccess(user);
      } catch (e) {
        history.push("/");
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  return (
    <Wrapper>
      <App user={user} />
    </Wrapper>
  );
}

export default withAuthenticationRequired(AdminDashboard);